class LeafletMap {

   constructor(element, options = {}) {
      this.el = element;
      this.zoomSettings = this.calculateZoom();
      this.zoomLevel = this.zoomSettings.zoomLevel;
      this.setMinZoom = this.zoomSettings.setMinZoom;
      this.resizeTimeout;
      this.markersData = [];
      this.markers = [];
      this.infoWindow;
      this.imageBounds = [[0, 0], [2117, 3214]];
      this.init();
    }

    init() {

      this.createMap();
      this.infoWindow();
      this.defineMarkers();
      this.createMarkers();

      window.addEventListener('resize', () => {
          this.resizeFunction(); // Corrected this to refer to the class instance
      });

    }

    calculateZoom() {
      var setMinZoom = -3.1;
      var zoomLevel = null;
      if (window.innerWidth > 500 && window.innerWidth < 600) {
        setMinZoom = -2.6;
      } else if(window.innerWidth >= 600 && window.innerWidth < 625) {
         setMinZoom = -2.45;
         zoomLevel = -2.4;
      } else if(window.innerWidth >= 625 && window.innerWidth < 650) {
         setMinZoom = -2.35;
         zoomLevel = -2.3;
      } else if(window.innerWidth >= 650 && window.innerWidth < 660) {
         setMinZoom = -2.3;
         zoomLevel = -2.3;
      } else if(window.innerWidth >= 660 && window.innerWidth < 700) {
        setMinZoom = -2.25;
        zoomLevel = -2.25;
      } else if(window.innerWidth >= 700 && window.innerWidth < 750) {
        setMinZoom = -2.2;
        zoomLevel = -2.2;
      } else if(window.innerWidth >= 750 && window.innerWidth < 810) {
        setMinZoom = -2.25;
      } else if(window.innerWidth >= 810) {
        setMinZoom = -2;
      } else {
         setMinZoom = -3.1;
      }

      return {'zoomLevel': zoomLevel, 'setMinZoom': setMinZoom};
    }

    createMap() {
      // 1. Create the map using Simple CRS (for a floorplan or image map)
      this.map = L.map('map', {
          crs: L.CRS.Simple,
          zoomSnap: 0.05,
          zoomDelta: 0.25,
          minZoom: this.setMinZoom,
          maxZoom: 0,
          maxBounds: [[0, 0], [2117, 3214]],
          maxBoundsViscosity: 1.0,
          //dragging: false
      });

      // 2. Add your floorplan image as an overlay
      var imageUrl = '/wp-content/themes/ap/assets/icons/map/250108-map.png';
      
      L.imageOverlay(imageUrl, this.imageBounds).addTo(this.map);

      //map.setView([1058.5, 1607], -2);
      this.map.fitBounds(this.imageBounds, {
          zoomSnap: 0.05,
          minZoom: this.setMinZoom,
          maxZoom: 0,
      });
      
      if(this.zoomLevel) {
        this.map.setZoom(this.zoomLevel);
      }

    }

    resizeFunction() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {

        // Recalculate zoom settings based on the new window size
        this.zoomSettings = this.calculateZoom();
        this.zoomLevel = this.zoomSettings.zoomLevel;
        this.setMinZoom = this.zoomSettings.setMinZoom;
        
        // Tell Leaflet the container size has changed
        this.map.invalidateSize();
        
        // Update the minZoom option if necessary (you can also use map.options.minZoom)
        this.map.options.minZoom = this.setMinZoom;
        
        // Re-fit the bounds and then adjust the zoom if defined
        this.map.fitBounds(this.imageBounds, { 
          zoomSnap: 0.05,
          minZoom: this.setMinZoom,
          maxZoom: 0,
        });
        
        if (this.zoomLevel !== null) {
          this.map.setZoom(this.zoomLevel);
        }
      }, 300); // adjust debounce time as needed
    }

    infoWindow() {

      // 4. Create a control for the info window
      this.infoWindow = L.control({ position: 'topright' });
      this.infoWindow.onAdd = function () {
          this._div = L.DomUtil.create('div', 'info');
          this._div.style.background = "white";
          this._div.style.padding = "10px";
          this._div.style.borderRadius = "5px";
          this._div.innerHTML = "Click on a marker to see info";
          return this._div;
      };
      this.infoWindow.addTo(this.map);

      console.log('Current zoom level:', this.map.getZoom());

      this.map.on('zoomend', function() {
        console.log('Current zoom level:', this.getZoom());
      });
    }

    defineMarkers() {

      // 5. Define markers (coords, info text, and icon URL)
      this.markersData = [
          {
            coords: [1590, 1400],
            infoText: '<h3 style="margin-block:0;">Palm Court Entrance</h3><p>Great Hall & West Hall Entrance</p>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-02.png'
          },
          {
            coords: [1530, 1355],
            infoText: '<h3 style="margin-block:0;">Phoenix Bar & Pizzeria</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-10.png'
          },
          {
            coords: [1500, 1760],
            infoText: '<h3 style="margin-block:0;">Ice Rink</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-07.png'
          },

          {
            coords: [1550, 1820],
            infoText: '<h3 style="margin-block:0;">Theatre</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-08.png'
          },
          {
            coords: [1400, 1930],
            infoText: '<h3 style="margin-block:0;">East Court Entrance</h3><p>Theatre, Ice Rink, East Court Cafe & Creativity Pavillion</p>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-03.png'
          },
          {
            coords: [1450, 1950],
            infoText: '<h3 style="margin-block:0;">Information</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-19.png'
          },
          {
            coords: [1450, 1880],
            infoText: '<h3 style="margin-block:0;">Cafe</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-09.png'
          },
          {
            coords: [1950, 820],
            infoText: '<h3 style="margin-block:0;">Cafe</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-09.png'
          },
          {
            coords: [1380, 1760],
            infoText: '<h3 style="margin-block:0;">Transmitter Hall</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-05.png'
          },
          {
            coords: [1560, 1640],
            infoText: '<h3 style="margin-block:0;">Great Hall</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-04.png'
          },
          {
            coords: [1550, 1530],
            infoText: '<h3 style="margin-block:0;">West Hall</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-06.png'
          }, 
          {
            coords: [1130, 1895],
            infoText: '<h3 style="margin-block:0;">Cafe</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-09.png'
          },
          {
            coords: [1570, 1325],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Palm Court (Stop B)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1550, 1305],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Palm Court (Stop R)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1580, 1095],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Garden Centre (Stop A)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1560, 1120],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Garden Centre (Stop S)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1335, 1550],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Ice Rink (Stop P)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1320, 2010],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Ice Rink (Stop C)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1115, 2295],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Park (Stop D)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1005, 2355],
            infoText: '<h3 style="margin-block:0;">Alexandra Palace Park (Stop N)</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-11.png'
          },

          {
            coords: [1795, 2107],
            infoText: '<h3 style="margin-block:0;">Toilets</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-12.png'
          },

          {
            coords: [1130, 1040],
            infoText: '<h3 style="margin-block:0;">Paddock Car Park</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-13.png'
          },

          {
            coords: [1380, 1998],
            infoText: '<h3 style="margin-block:0;">Dives Car Park</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-14.png'
          },

          {
            coords: [1525, 2015],
            infoText: '<h3 style="margin-block:0;">Pavillion Car Park</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-15.png'
          },

          {
            coords: [1370, 1905],
            infoText: '<h3 style="margin-block:0;">East Car Park</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-16.png'
          },
          {
            coords: [1700, 1090],
            infoText: '<h3 style="margin-block:0;">Grove Car Park</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-17.png'
          },

          {
            coords: [1110, 480],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [1030, 495],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [670, 1135],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [640, 1530],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [135, 2030],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [850, 2785],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [1508, 2450],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [1923, 1700],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [1700, 1620],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [1850, 1230],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [2005, 390],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [1605, 990],
            infoText: '<h3 style="margin-block:0;">Park Entrance</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-18.png'
          },
          {
            coords: [770, 1575],
            infoText: '<h3 style="margin-block:0;">Helipad</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/Icon-20.png'
          },
          {
            coords: [1630, 2175],
            infoText: '<h3 style="margin-block:0;">Go Ape</h3>',
            iconUrl: '/wp-content/themes/ap/assets/icons/map/go-ape.png'
          },
          
      ];
  }

  // 6. A helper function to create an icon sized based on current zoom
  createIcon(iconUrl, zoom) {
    var baseSize = iconUrl === '/wp-content/themes/ap/assets/icons/map/go-ape.png' ? 30 : 12;  
    
    // For example, let's have them grow by ~20% for each zoom level above -2
    // so if zoom = -2 => scaleFactor ~ 1; if zoom = -1 => ~1.2, etc.
    var scaleFactor = Math.pow(1.3, zoom - (-2));
    
    var newSize = baseSize * scaleFactor;
    
    return L.icon({
      iconUrl: iconUrl,
      iconSize: [newSize, newSize],
      iconAnchor: [newSize / 2, newSize] // anchor so bottom is the location
    });
  }

  createMarkers() {
    // 7. Create Leaflet marker objects and store references so we can update later
    this.markers = []; // will store the actual Leaflet marker instances

    this.markersData.forEach((markerData) => {  // Use arrow function
      console.log('markerData', markerData);
      var leafletMarker = L.marker(
        [markerData.coords[0], markerData.coords[1]],
        {
          icon: this.createIcon(markerData.iconUrl, this.map.getZoom())  // 'this' correctly refers to the class
        }
      )
      .addTo(this.map)
      .on('click', () => {  // Arrow function to keep 'this' for the event handler
        // Update the info window content when a marker is clicked
        this.infoWindow._div.innerHTML = markerData.infoText;
      });

      this.markers.push(leafletMarker);
    });

    // 8. On zoom end, update icon sizes for all markers
    this.map.on('zoomend', () => {  // Arrow function to keep 'this' for the zoom handler
      var currentZoom = this.map.getZoom();

      this.markers.forEach((leafletMarker) => {  // Arrow function for iteration
        var iconUrl = leafletMarker.options.icon.options.iconUrl;
        
        // Create a new icon based on the current zoom
        var updatedIcon = this.createIcon(iconUrl, currentZoom);

        // Apply the updated icon to the marker
        leafletMarker.setIcon(updatedIcon);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
   if(document.getElementById('map')== null) return;
    var leafletMap = new LeafletMap(document.getElementById('map'));
});
